/* eslint-disable */
/* global $, data, query_string */
import table from 'bam-node-savant-table/table'

import { toFixed } from '../utils'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'pop_time'

$(document).ready(() => {
    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            // console.log(width);
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $('.default-table-row')
                .first()
                .children('td')
                .each(function () {
                    const rowWidth = $(this).outerWidth()
                    $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell++
                })

            $(`#${divId} table thead`).addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $('.tr-component-row')
                .children('th')
                .each(function () {
                    const rowWidth = $(this).outerWidth()
                    $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell++
                })
        }
    }

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function populateUrl() {
        const url = `/leaderboard/poptime?year=${$(
            '#ddlSeason'
        ).val()}&team=${$('#ddlTeamId').val()}&min2b=${$(
            '#ddlMin2b'
        ).val()}&min3b=${$('#ddlMin3b').val()}&sort=${$(
            '#sort'
        ).val()}&sortDir=${$('#sortDir').val()}`
        window.history.pushState('', '', url)
        return url
    }

    $('form').submit(false)

    $('#ddlTeamId').change(() => {
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    })

    $('#ddlSeason').change(() => {
        $('#lblSeason').html($('#ddlSeason').val())
    })
    $('#ddlMin2b').change(() => {
        $('#lblMin2b').html(`Min 2B Attempts (${$('#ddlMin2b').val()})`)
    })
    $('#ddlMin3b').change(() => {
        $('#lblMin3b').html(`Min 3B Attempts (${$('#ddlMin3b').val()})`)
    })

    if (query_string.min2b) {
        $('#ddlMin2b').val(query_string.min2b).attr('selected', true)
        $('#lblMin2b').html(`Min 2B Attempts (${$('#ddlMin2b').val()})`)
    }
    if (query_string.min3b) {
        $('#ddlMin3b').val(query_string.min3b).attr('selected', true)
        $('#lblMin3b').html(`Min 3B Attempts (${$('#ddlMin3b').val()})`)
    }

    if (query_string.year) {
        $('#ddlSeason').val(query_string.year).attr('selected', true)
        $('#lblSeason').html($('#ddlSeason').val())
    }

    if (query_string.team) {
        $('#ddlTeamId').val(query_string.team).attr('selected', true)
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    }

    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }

    if (data && data.length > 0) {
        const headers = [
            {
                name: 'Catcher',
                field: 'href',
                customSortField: 'catcher',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'catcher_id',
            },
            {
                name: 'Team',
                field: 'team_name_abbrev',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                photoId: 'team_id',
                photoOnly: true,
            },
            {
                name: 'Age',
                field: 'age',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'Arm',
                field: 'maxeff_arm_2b_3b_sba',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: toFixed(1, '--'),
            },
            {
                name: 'Exchange',
                field: 'exchange_2b_3b_sba',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: toFixed(2),
            },
            {
                name: 'Att.',
                field: 'pop_2b_sba_count',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                type: 'number',
            },
            {
                name: 'All',
                field: 'pop_2b_sba',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                highlight: [2.15, 2.0, 1.9],
                displayFn: toFixed(2, '-.--'),
            },
            {
                name: 'CS',
                field: 'pop_2b_cs',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: toFixed(2, '-.--'),
            },
            {
                name: 'SB',
                field: 'pop_2b_sb',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: toFixed(2, '-.--'),
            },
            {
                name: 'Att.',
                field: 'pop_3b_sba_count',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
                type: 'number',
            },
            {
                name: 'All',
                field: 'pop_3b_sba',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: toFixed(2, '-.--'),
            },
            {
                name: 'CS',
                field: 'pop_3b_cs',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                type: 'number',
                displayFn: toFixed(2, '-.--'),
            },
            {
                name: 'SB',
                field: 'pop_3b_sb',
                headerClass: 'th-component-header border-right-pop',
                fieldClass: 'tr-data border-right-pop',
                type: 'number',
                displayFn: toFixed(2, '-.--'),
            },
        ]

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }

        // eslint-disable-next-line
        new table({
            id: 'pop_time',
            repeatHeader: repeatHeaders,
            secondaryHeaders: [
                {
                    name: '',
                    colspan: 6,
                    headerClass: 'th-name-header',
                },
                {
                    name: 'Pop Time 2B (Avg)',
                    colspan: 4,
                    headerClass: 'th-title-header',
                },
                {
                    name: 'Pop Time 3B (Avg)',
                    colspan: 4,
                    headerClass: 'th-title-header',
                },
            ],
            headers,
            data,
            defaultSort: headers[Number($('#sort').val())].field,
            defaultSortDirection: $('#sortDir').val(),
            sortClass: 'column-sort',
            showRank: true,
        })
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    $('#btnUpdate').click(() => {
        window.location.href = `/leaderboard/poptime?year=${$(
            '#ddlSeason'
        ).val()}&team=${$('#ddlTeamId').val()}&min2b=${$(
            '#ddlMin2b'
        ).val()}&min3b=${$('#ddlMin3b').val()}`
    })

    $('#btnCSV').click(() => {
        window.location.href = `/leaderboard/poptime?year=${$(
            '#ddlSeason'
        ).val()}&team=${$('#ddlTeamId').val()}&min2b=${$(
            '#ddlMin2b'
        ).val()}&min3b=${$('#ddlMin3b').val()}&csv=true`
    })

    $(document).on('click', 'th.th-component-header', function () {
        const id = this.id.split('-')[1]

        if (Number($('#sort').val()) === Number(id)) {
            if ($('#sortDir').val() === 'desc') {
                $('#sortDir').val('asc')
            } else {
                $('#sortDir').val('desc')
            }
        } else {
            $('#sortDir').val('desc')
        }
        $('#sort').val(id)
        isFixedHeaderShowing = false
        checkHeaderPosition(tableDivId)
        populateUrl()
    })

    window.addEventListener('scroll', () => {
        if (!ticking && data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })
})
